<template>
  <div>
    <team-member
      v-for="member in members"
      :key="member.id"
      :me-profile="meProfile"
      :member="member"
      @give-kudo="$emit('give-kudo', $event)"
      @send-message="$emit('send-message', $event)"
    />
  </div>
</template>

<script>
import TeamMember from './TeamMemeber.vue'

export default {
  name: 'TeamMemberList',

  props: {
    members: {
      type: Array,
      default: () => ([])
    },

    meProfile: {
      type: Number
    }
  },

  components: {
    TeamMember
  }
}
</script>
